import React, { useState } from 'react';
import { Accordion, AppBar, Toolbar, IconButton, AccordionDetails, AccordionSummary, Typography, Box, Divider, Button, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import logo from './assets/logo.png'; // Import the logo image
import TuneIcon from '@mui/icons-material/Tune'; // Filter icon for FAB
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RateReviewIcon from '@mui/icons-material/RateReview';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TimerIcon from '@mui/icons-material/Timer';

// Sample order data (same as before)
const orders = [
    {
        id: 1, orderNumber: 'ORD001', customer: 'John Doe', status: 'Pending', date: '2025-01-08T19:31:01', total: 120, totalItems: 2, items: [
            { name: 'Burger', quantity: 1, ingredientsRequest: 'No Pickles' },
            { name: 'Fries', quantity: 2, ingredientsRequest: '' }
        ]
    },
    {
        id: 2, orderNumber: 'ORD002', customer: 'Jane Smith', status: 'Completed', date: '2025-01-08T19:20:00', total: 75, totalItems: 2, items: [
            { name: 'Salad', quantity: 1, ingredientsRequest: '' },
            { name: 'Chicken Sandwich', quantity: 1, ingredientsRequest: 'Add Bacon' },
        ]
    },
    {
        id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
            { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
            { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
            { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
        ]
    },
    {
        id: 4, orderNumber: 'ORD004', customer: 'Emily Davis', status: 'Completed', date: '2025-01-07T14:40:10', total: 80, totalItems: 2, items: [
            { name: 'Grilled Chicken Salad', quantity: 1, ingredientsRequest: 'Dressing on the side' },
            { name: 'Iced Tea', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 5, orderNumber: 'ORD005', customer: 'Michael Brown', status: 'Pending', date: '2025-01-08T12:30:45', total: 95, totalItems: 3, items: [
            { name: 'Cheeseburger', quantity: 1, ingredientsRequest: 'No Lettuce' },
            { name: 'Sweet Potato Fries', quantity: 1, ingredientsRequest: '' },
            { name: 'Soda', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 6, orderNumber: 'ORD006', customer: 'Sarah White', status: 'Processing', date: '2025-01-07T17:20:30', total: 110, totalItems: 3, items: [
            { name: 'Veggie Wrap', quantity: 1, ingredientsRequest: 'Add Guacamole' },
            { name: 'Chips', quantity: 1, ingredientsRequest: '' },
            { name: 'Lemonade', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 7, orderNumber: 'ORD007', customer: 'David Clark', status: 'Completed', date: '2025-01-06T15:10:50', total: 140, totalItems: 4, items: [
            { name: 'Fish Tacos', quantity: 2, ingredientsRequest: '' },
            { name: 'Rice', quantity: 1, ingredientsRequest: 'Extra Sauce' },
            { name: 'Soda', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 8, orderNumber: 'ORD008', customer: 'Laura Lewis', status: 'Pending', date: '2025-01-08T16:45:20', total: 65, totalItems: 2, items: [
            { name: 'Caesar Salad', quantity: 1, ingredientsRequest: 'No Croutons' },
            { name: 'Water', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 9, orderNumber: 'ORD009', customer: 'James Harris', status: 'Completed', date: '2025-01-08T13:10:15', total: 170, totalItems: 4, items: [
            { name: 'Steak', quantity: 1, ingredientsRequest: 'Medium Rare' },
            { name: 'Mashed Potatoes', quantity: 1, ingredientsRequest: '' },
            { name: 'Broccoli', quantity: 1, ingredientsRequest: 'Extra Butter' },
            { name: 'Wine', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 10, orderNumber: 'ORD010', customer: 'Jessica Miller', status: 'Processing', date: '2025-01-07T19:05:00', total: 135, totalItems: 3, items: [
            { name: 'Chicken Alfredo', quantity: 1, ingredientsRequest: 'Extra Cheese' },
            { name: 'Breadsticks', quantity: 2, ingredientsRequest: '' },
            { name: 'Coke', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 11, orderNumber: 'ORD011', customer: 'Kevin Moore', status: 'Completed', date: '2025-01-06T14:30:25', total: 50, totalItems: 2, items: [
            { name: 'Hot Dog', quantity: 1, ingredientsRequest: 'No Onions' },
            { name: 'Fries', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 12, orderNumber: 'ORD012', customer: 'Anna Walker', status: 'Pending', date: '2025-01-08T10:00:05', total: 60, totalItems: 2, items: [
            { name: 'Soup', quantity: 1, ingredientsRequest: 'Extra Croutons' },
            { name: 'Bread Roll', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 13, orderNumber: 'ORD013', customer: 'Chris Young', status: 'Completed', date: '2025-01-07T18:55:30', total: 95, totalItems: 3, items: [
            { name: 'Club Sandwich', quantity: 1, ingredientsRequest: 'Add Avocado' },
            { name: 'Potato Chips', quantity: 1, ingredientsRequest: '' },
            { name: 'Iced Coffee', quantity: 1, ingredientsRequest: 'No Ice' }
        ]
    },
    {
        id: 14, orderNumber: 'ORD014', customer: 'Karen King', status: 'Pending', date: '2025-01-08T11:50:45', total: 45, totalItems: 1, items: [
            { name: 'Fruit Salad', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 15, orderNumber: 'ORD015', customer: 'Paul Scott', status: 'Processing', date: '2025-01-07T20:30:10', total: 180, totalItems: 4, items: [
            { name: 'Ribeye Steak', quantity: 1, ingredientsRequest: 'Well Done' },
            { name: 'Baked Potato', quantity: 1, ingredientsRequest: 'Extra Sour Cream' },
            { name: 'Caesar Salad', quantity: 1, ingredientsRequest: 'No Dressing' },
            { name: 'Beer', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 16, orderNumber: 'ORD016', customer: 'Lily Green', status: 'Completed', date: '2025-01-08T18:00:30', total: 110, totalItems: 3, items: [
            { name: 'Vegetable Stir Fry', quantity: 1, ingredientsRequest: 'Extra Tofu' },
            { name: 'Spring Rolls', quantity: 2, ingredientsRequest: '' },
            { name: 'Orange Juice', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 17, orderNumber: 'ORD017', customer: 'Oscar Taylor', status: 'Pending', date: '2025-01-08T17:45:00', total: 95, totalItems: 3, items: [
            { name: 'Cheese Pizza', quantity: 1, ingredientsRequest: 'Add Mushrooms' },
            { name: 'Garlic Bread', quantity: 1, ingredientsRequest: '' },
            { name: 'Coke', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 18, orderNumber: 'ORD018', customer: 'Emma Wilson', status: 'Processing', date: '2025-01-07T15:20:40', total: 150, totalItems: 4, items: [
            { name: 'Spaghetti Bolognese', quantity: 1, ingredientsRequest: '' },
            { name: 'Salad', quantity: 1, ingredientsRequest: 'No Dressing' },
            { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Garlic' },
            { name: 'Red Wine', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 19, orderNumber: 'ORD019', customer: 'Henry Adams', status: 'Completed', date: '2025-01-06T12:40:15', total: 85, totalItems: 3, items: [
            { name: 'BBQ Ribs', quantity: 1, ingredientsRequest: 'Extra Sauce' },
            { name: 'Coleslaw', quantity: 1, ingredientsRequest: '' },
            { name: 'Beer', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 20, orderNumber: 'ORD020', customer: 'Sophia Moore', status: 'Pending', date: '2025-01-08T14:30:00', total: 120, totalItems: 3, items: [
            { name: 'Grilled Salmon', quantity: 1, ingredientsRequest: 'No Lemon' },
            { name: 'Steamed Asparagus', quantity: 1, ingredientsRequest: '' },
            { name: 'Sparkling Water', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 21, orderNumber: 'ORD021', customer: 'Lucas Evans', status: 'Processing', date: '2025-01-07T16:10:05', total: 140, totalItems: 3, items: [
            { name: 'Beef Tacos', quantity: 2, ingredientsRequest: '' },
            { name: 'Rice', quantity: 1, ingredientsRequest: 'Extra Salsa' },
            { name: 'Guacamole', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 22, orderNumber: 'ORD022', customer: 'Ava Collins', status: 'Completed', date: '2025-01-06T11:45:30', total: 115, totalItems: 3, items: [
            { name: 'Chicken Caesar Wrap', quantity: 1, ingredientsRequest: 'Add Parmesan' },
            { name: 'Fries', quantity: 1, ingredientsRequest: '' },
            { name: 'Lemonade', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 23, orderNumber: 'ORD023', customer: 'Benjamin Lewis', status: 'Pending', date: '2025-01-08T13:25:55', total: 130, totalItems: 4, items: [
            { name: 'Cheese Burger', quantity: 1, ingredientsRequest: 'No Onions' },
            { name: 'Curly Fries', quantity: 1, ingredientsRequest: '' },
            { name: 'Milkshake', quantity: 1, ingredientsRequest: '' },
            { name: 'Soda', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 24, orderNumber: 'ORD024', customer: 'Charlotte Harris', status: 'Completed', date: '2025-01-07T20:55:30', total: 105, totalItems: 3, items: [
            { name: 'Chicken Nuggets', quantity: 1, ingredientsRequest: '' },
            { name: 'Fries', quantity: 1, ingredientsRequest: 'Extra Salt' },
            { name: 'Iced Tea', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 25, orderNumber: 'ORD025', customer: 'William Martin', status: 'Processing', date: '2025-01-08T16:10:10', total: 90, totalItems: 3, items: [
            { name: 'Pasta Primavera', quantity: 1, ingredientsRequest: 'Add Chicken' },
            { name: 'Garlic Bread', quantity: 1, ingredientsRequest: '' },
            { name: 'Soda', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 26, orderNumber: 'ORD026', customer: 'Mason Perez', status: 'Pending', date: '2025-01-08T09:40:20', total: 80, totalItems: 2, items: [
            { name: 'Caesar Salad', quantity: 1, ingredientsRequest: 'Add Bacon' },
            { name: 'Water', quantity: 1, ingredientsRequest: '' }
        ]
    },
    {
        id: 27, orderNumber: 'ORD027', customer: 'Ethan Roberts', status: 'Completed', date: '2025-01-06T18:00:45', total: 170, totalItems: 5, items: [
            { name: 'Steak Frites', quantity: 1, ingredientsRequest: 'Medium' },
            { name: 'Mac and Cheese', quantity: 1, ingredientsRequest: '' },
            { name: 'Green Beans', quantity: 1, ingredientsRequest: '' },
            { name: 'Bread Roll', quantity: 1, ingredientsRequest: '' },
            { name: 'Wine', quantity: 1, ingredientsRequest: '' }
        ]
    }
];


const History = () => {
    const navigate = useNavigate();
    const handleReturnClick = () => {
        navigate('/orders');
    };
    // Pagination logic
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 12;

    // Search state
    const [searchQuery, setSearchQuery] = useState('');

    // Helper function to format date
    const formatDate = (date) => {
        return new Date(date).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    };

    // Filter orders by search query
    const filteredOrders = orders.filter((order) =>
        order.orderNumber.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Get the current orders based on the page
    const currentOrders = filteredOrders.slice((currentPage - 1) * ordersPerPage, currentPage * ordersPerPage);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    return (
        <div style={{ padding: '0px', backgroundColor: '#2e2e2e', minHeight: '100vh' }}>
            <AppBar position="static" style={{ backgroundColor: '#336699' }}>
                <Toolbar>
                    <Box display="flex" alignItems="center" justifyContent="flex-start" style={{ flexGrow: 1 }}>
                        <img
                            src={logo} // Path to your Logo.png image
                            alt="Logo"
                            style={{
                                height: '50px', // Adjust the size of the logo
                                width: 'auto',
                            }}
                        />
                    </Box>
                    <IconButton edge="end" color="inherit" aria-label="book" href="/orders" style={{ marginLeft: '3.5%' }}>
                        <TimerIcon />
                    </IconButton>
                    <IconButton edge="end" color="inherit" aria-label="book" href="/menu" style={{ marginLeft: '3.5%' }}>
                        <BorderColorIcon />
                    </IconButton>
                    <IconButton edge="end" color="inherit" aria-label="book" href="/history" style={{ marginLeft: '3.5%' }}>
                        <AutoStoriesIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ padding: '20px', backgroundColor: '#2e2e2e', minHeight: '100vh' }}>

                <div style={{ display: 'flex', gap: '20px' }} >

                    <Typography variant="h4" gutterBottom style={{ color: '#fff' }}>
                        Order History
                    </Typography>

                    <Button
                        variant="contained"
                        color="error"
                        style={{
                            color: 'white', // Text color

                            height: '40px', // Larger height
                            fontSize: '.8rem', // Larger font size
                            padding: '5px', // Adjust padding if needed
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            marginTop: '2px'

                        }}
                        onClick={handleReturnClick}
                    >
                        Return Home
                    </Button>

                </div>
                {/* Search field */}
                <Box mb={2}>
                    <TextField
                        label="Search by Order Number"
                        variant="outlined"
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ backgroundColor: '#fff', borderRadius: '10px' }}
                    />
                </Box>

                {/* Accordion for each order */}
                {currentOrders.length === 0 && (
                    <Typography variant="h6" style={{ color: '#fff' }}>
                        No orders found
                    </Typography>
                )}

                {currentOrders.map((order) => (
                    <Accordion key={order.id} sx={{ borderRadius: '10px', backgroundColor: '#444', color: '#fff', marginBottom: '10px' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${order.id}-content`} id={`panel${order.id}-header`}>
                            <Typography variant="h6" style={{ fontSize: '18px' }}>
                                {order.orderNumber} - {formatDate(order.date)}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                    <strong>Customer:</strong> {order.customer}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                    <strong>Status:</strong> {order.status}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                    <strong>Total:</strong> ${order.total}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                    <strong>Total Items:</strong> {order.totalItems}
                                </Typography>

                                {/* Divider between order summary and items */}
                                <Divider style={{ margin: '10px 0', backgroundColor: '#ccc' }} />

                                {/* Render order items */}
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
                                    {order.items.map((item, index) => (
                                        <Box key={index} style={{ color: '#fff' }}>
                                            <Typography variant="body2" style={{ fontSize: '16px' }}>
                                                {item.quantity} x {item.name}
                                            </Typography>
                                            {item.ingredientsRequest && (
                                                <Typography variant="body2" style={{ color: '#e0e0e0', fontSize: '14px' }}>
                                                    Ingredients Request: {item.ingredientsRequest}
                                                </Typography>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                ))}

                {/* No orders found message */}
                {currentOrders.length === 0 && (
                    <Typography variant="body1" style={{ color: '#e0e0e0' }}>
                        Try a different search term.
                    </Typography>
                )}

                {/* Pagination buttons */}
                <Box display="flex" justifyContent="center" marginTop="20px">
                    <Button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        variant="contained"
                        color="primary"
                        style={{ marginRight: '10px' }}
                    >
                        Previous
                    </Button>
                    <Button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage * ordersPerPage >= filteredOrders.length}
                        variant="contained"
                        color="primary"
                    >
                        Next
                    </Button>
                </Box>
            </div>
        </div>
    );
};

export default History;
